<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="col-xl-12">
      <div class="row">
        <div class="col-lg-4">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div>
                  <p class="text-muted mb-2">Mes dossiers</p>
                  <h5 class="mb-0" v-if="!loading">{{ foldres.total_count }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" class="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-icon">
                      <i class="mdi mdi-file-multiple-outline font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Mes favoris</p>
                  <h5 class="mb-0" v-if="!loadingFavorites">{{ favorites.total_count }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" class="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle vivacious-color">
                    <span class="avatar-icon">
                      <i class="bx bx-bookmark font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Mes brouillons</p>
                  <h5 class="mb-0" v-if="!loadingDraft">{{ listDraft.total_count }}</h5>
                  <b-spinner v-else variant="success" label="Spinning" class="text-center"></b-spinner>
                </div>
                <div class="avatar-sm ms-auto mt-1">
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle lochmara-color">
                    <span class="avatar-icon">
                      <i class="bx bx-edit-alt font-size-24"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="" nav-class="nav-tabs-custom">
              <b-tab title="Mes dossiers" active>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="mt-4">
                        <!-- App Search-->
                        <form class="app-search d-none d-lg-block">
                          <div class="position-relative">
                            <input
                                v-model="filterKeyword"
                                type="search"
                                class="form-control"
                                :placeholder="$t('navbar.search.text')"
                                @input="getFilter"
                            />
                            <span class="bx bx-search-alt"></span>
                          </div>
                        </form>
                        <div class="table-responsive">
                          <b-table class="table mb-0 table-responsive  table-light" hover responsive="sm"
                                   :items="listFilter" :fields="headerTableFolders"
                                   :per-page="10" :current-page="currentPage">
                            <!-- A custom Type column -->
                            <template #cell(id)="element">
                              <td v-if="element.item.id">
                                <h5 class="font-size-14 mb-1">
                                  {{ element.item.id }}
                                </h5>
                              </td>
                              <td v-else class="text-muted-color ">Aucune données</td>
                            </template>
                            <template #cell(folder)="element">
                              <td v-if="element.item.s_type_bien && element.item.s_usage_bien"
                                  class="title-width">
                                {{
                                  demandTypeStatus(element.item.s_type_bien) + ' ' + useStatus(element.item.s_usage_bien) | truncate(33, " ...")
                                }}
                              </td>
                              <td v-else class="text-muted-color ">Aucune données</td>
                            </template>
                            <template #cell(date)="element">
                              <td v-if="element.item.createdAt">{{ formatDate(element.item.createdAt) }}</td>
                              <td v-else class="text-muted-color">Aucune données</td>
                            </template>
                            <template #cell(amount)="element">
                              <td v-if="element.item.s_montant_global">
                                {{ element.item.s_montant_global | truncateMontant() }}
                              </td>
                              <td v-else class="text-muted-color">Aucune données</td>
                            </template>
                            <template #cell(type)="element">
                              <td v-if="element.item.s_type_bien">
                                {{ demandTypeStatus(element.item.s_type_bien)  | truncate(25, " ...") }}
                              </td>
                              <td v-else class="text-muted-color">Aucune données</td>
                            </template>
                            <template #cell(status)="element">
                              <td>
                                 <span v-if="statusData(element.item.internal_status, statusFolder)"
                                       class="badge font-size-11 "
                                       :class="statusData(element.item.internal_status, statusFolder).class">
                                   {{ statusData(element.item.internal_status, statusFolder).name }}
                                 </span>
                                <span v-else class="text-muted-color">Aucune données</span>
                              </td>
                            </template>
                            <template #cell(Use)="element">
                              <td v-if="element.item.s_usage_bien">
                                {{ useStatus(element.item.s_usage_bien) }}
                              </td>
                              <td v-else class="text-muted-color">Aucune données</td>
                            </template>
                            <template #cell(action)="element">
                              <td>
                                <b-button pill variant="primary" size="sm"
                                          @click="redirection(element.item.id)"> Voir détails
                                </b-button>
                              </td>
                            </template>
                          </b-table>
                          <div v-if="loading" class="mt-2 mb-2">
                            <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                          </div>
                        </div>
                        <div
                            v-if=" !loading && filterKeyword !== '' && listFilter.length === 0 || !loading && foldres.total_count === 0 && filterKeyword === ''"
                            class="mt-2">
                          <b-alert show variant="danger">
                            <i class="mdi mdi-block-helper me-2"></i><strong>Aucune </strong> donnée disponible
                          </b-alert>
                        </div>
                        <!-- Pagination -->
                        <Pagination
                            @changePage="onPaginate($event ,1)"
                            :page="currentPage" :itemsPerPage="10" :list="listFilter"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Mes favoris">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="mt-4">
                        <div class="table-responsive">
                          <div class="table-responsive">
                            <b-table class="table mb-0 table-responsive  table-light" hover responsive="sm"
                                     :items="favorites.items" :fields="headerTableFolders"
                                     :per-page="10" :current-page="currentPageFav">
                              <!-- A custom Type column -->
                              <template #cell(id)="element">
                                <td v-if="element.item.id">
                                  <h5 class="font-size-14 mb-1">
                                    {{ element.item.id }}
                                  </h5>
                                </td>
                                <td v-else class="text-muted-color ">Aucune données</td>
                              </template>
                              <template #cell(folder)="element">
                                <td v-if="element.item.s_type_bien && element.item.s_usage_bien"
                                    class="title-width">
                                  {{
                                    demandTypeStatus(element.item.s_type_bien) + ' ' + useStatus(element.item.s_usage_bien) | truncate(33, " ...")
                                  }}
                                </td>
                                <td v-else class="text-muted-color ">Aucune données</td>
                              </template>
                              <template #cell(date)="element">
                                <td v-if="element.item.createdAt">{{ formatDate(element.item.createdAt) }}</td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(amount)="element">
                                <td v-if="element.item.s_montant_global">
                                  {{ element.item.s_montant_global | truncateMontant() }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(type)="element">
                                <td v-if="element.item.s_type_bien">
                                  {{ demandTypeStatus(element.item.s_type_bien)  | truncate(25, " ...") }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(status)="element">
                                <td>
                                 <span v-if="statusData(element.item.internal_status, statusFolder)"
                                       class="badge font-size-11 "
                                       :class="statusData(element.item.internal_status, statusFolder).class">
                                   {{ statusData(element.item.internal_status, statusFolder).name }}
                                 </span>
                                  <span v-else class="text-muted-color">Aucune données</span>
                                </td>
                              </template>
                              <template #cell(Use)="element">
                                <td v-if="element.item.s_usage_bien">
                                  {{ useStatus(element.item.s_usage_bien) }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(action)="element">
                                <td>
                                  <b-button pill variant="primary" size="sm"
                                            @click="redirection(element.item.id)"> Voir détails
                                  </b-button>
                                </td>
                              </template>
                            </b-table>
                            <div v-if="loadingFavorites" class="mt-2 mb-2">
                              <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                            </div>
                          </div>
                          <div v-if="favorites.total_count===0 && !loadingFavorites" class="mt-2">
                            <b-alert show variant="danger">
                              <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> dossier
                              favoris
                            </b-alert>
                          </div>

                        </div>
                        <!-- Pagination -->
                        <Pagination
                            @changePage="onPaginate($event ,2)"
                            :page="currentPageFav" :itemsPerPage="10" :list="favorites.items"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Mes brouillons">
                <div class="row" v-if="listDraft">
                  <div class="col-lg-12">
                    <div class="card">
                      <div class="mt-4">
                        <div class="table-responsive">
                          <div class="table-responsive">
                            <b-table class="table mb-0 table-responsive  table-light" hover responsive="sm"
                                     :items="listDraft.items" :fields="headerTableFolders"
                                     :per-page="10" :current-page="currentPageBr">
                              <!-- A custom Type column -->
                              <template #cell(id)="element">
                                <td v-if="element.item.id">
                                  <h5 class="font-size-14 mb-1">
                                    {{ element.item.id }}
                                  </h5>
                                </td>
                                <td v-else class="text-muted-color ">Aucune données</td>
                              </template>
                              <template #cell(folder)="element">
                                <td v-if="element.item.s_type_bien && element.item.s_usage_bien"
                                    class="title-width">
                                  {{demandTypeStatus(element.item.s_type_bien) + ' ' + useStatus(element.item.s_usage_bien) | truncate(33, " ...") }}
                                </td>
                                <td v-else class="text-muted-color ">Aucune données</td>
                              </template>
                              <template #cell(date)="element">
                                <td v-if="element.item.createdAt">{{ formatDate(element.item.createdAt) }}</td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(amount)="element">
                                <td v-if="element.item.s_montant_global">
                                  {{ element.item.s_montant_global | truncateMontant() }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(type)="element">
                                <td v-if="element.item.s_type_bien">
                                  {{ demandTypeStatus(element.item.s_type_bien)  | truncate(25, " ...") }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(status)="element">
                                <td>
                                 <span v-if="statusData(element.item.internal_status, statusFolder)"
                                       class="badge font-size-11 "
                                       :class="statusData(element.item.internal_status, statusFolder).class">
                                   {{ statusData(element.item.internal_status, statusFolder).name }}
                                 </span>
                                  <span v-else class="text-muted-color">Aucune données</span>
                                </td>
                              </template>
                              <template #cell(Use)="element">
                                <td v-if="element.item.s_usage_bien">
                                  {{ useStatus(element.item.s_usage_bien) }}
                                </td>
                                <td v-else class="text-muted-color">Aucune données</td>
                              </template>
                              <template #cell(action)="element">
                                <td>
                                  <b-button pill variant="primary" size="sm"
                                            @click="redirection(element.item.id)"> Voir détails
                                  </b-button>
                                </td>
                              </template>
                            </b-table>
                            <div v-if="loadingDraft" class="mt-2 mb-2">
                              <b-spinner small label="Small Spinner" variant="success"></b-spinner>
                            </div>
                          </div>
                          <div v-if="favorites.total_count===0 && !loadingFavorites" class="mt-2">
                            <b-alert show variant="danger">
                              <i class="mdi mdi-block-helper me-2"></i>Vous n’avez <strong>aucun</strong> dossier
                              favoris
                            </b-alert>
                          </div>
                        </div>
                        <!-- Pagination -->
                        <Pagination
                            @changePage="onPaginate($event ,3)"
                            :page="currentPageBr" :itemsPerPage="9" :list="listDraft.items"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {statusFolder} from "@/router/views/proposals/statusData";
import Pagination from "@/components/pagination";
import {titlesHeaderFoldersModel} from "@/router/views/titlesHeaderModel";

/**
 * Users component
 */
export default {
  page: {
    title: "Dossiers",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader, Pagination},
  data() {
    return {
      title: "Dossiers",
      filterKeyword: '',
      listFilter: [],
      totalCount: 0,
      items: [
        {
          text: "Fibourse",
          href: "/",
        },
        {
          text: "Mes dossiers",
          active: true,
        },
      ],
      currentPage: 1,
      currentPageFav: 1,
      currentPageBr: 1,
      headerTableFolders: titlesHeaderFoldersModel,
      statusFolder: [],
    };
  },
  created() {
    this.statusFolder = statusFolder;
    this.getList();
    this.$store.dispatch("mesdoc/folderFavorites");
    this.$store.dispatch("mesdoc/listDraft");
  },
  methods: {
    // Get list of folders
    getList() {
      this.$store.dispatch("mesdoc/list");
    },
    getFilter() {
      this.listFilter = this.foldres.items;
      this.listFilter = (this.filterKeyword)
          ? this.listFilter.filter(item => this.demandTypeStatus(item.s_type_bien).toUpperCase().includes(this.filterKeyword.toUpperCase()) || this.useStatus(item.s_usage_bien).toUpperCase().includes(this.filterKeyword.toUpperCase()))
          : this.foldres.items;
      this.totalCount = this.listFilter.length;
    },
    // Page pagination next/previous
    movePages(p) {
      if (p !== this.currentPage) {
        this.currentPage = p;
        this.getList();
      }
    },
    matcDataFolders(data) {
      this.totalCount = data.total_count;
      this.listFilter = data.items;
    },
    redirection(root) {
      this.$root.$router.push({
        path: '/folders/' + root,
        params: {test: 'folders'},
        query: {name: 'folders'}
      })
    },
    /* change page */
    onPaginate(event, id) {
      (id === 1) ? this.currentPage = event : (id === 2) ? this.currentPageFav = event : this.currentPageBr = event;
    },
  },
  computed: {
    // Get folders data from store
    foldres() {
      let data = this.$store.getters["mesdoc/getList"];
      if (data) {
        this.matcDataFolders(data);
      }
      return data;
    },
    favorites() {
      return this.$store.getters["mesdoc/getFavorites"];
    },
    listDraft() {
      return this.$store.getters["mesdoc/getDraft"];
    },
    loading() {
      return this.$store.getters["mesdoc/getIsLoading"];
    },
    loadingFavorites() {
      return this.$store.getters["mesdoc/getIsLoadingFavorites"];
    },
    loadingDraft() {
      return this.$store.getters["mesdoc/getIsLoadingDraft"];
    },
    // Calcul the total pages
    pagination() {
      let n = Math.round(this.list.length / 10);
      if (Number.isInteger(n)) {
        return n + 1;
      }
      return n;
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    truncateMontant: function (text) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(text)
    },
  },
};
</script>


<style scoped lang="scss">
::v-deep .nav-tabs-custom .nav-item .nav-link.active {
  color: #1F71D2;
}

::v-deep .nav-tabs-custom .nav-item .nav-link::after {
  background: #1F71D2;
}

.font-size-70 {
  width: 70px
}

::v-deep thead {
  color: #000000;
  border-color: #eff2f7;
  background-color: #eff2f7;
}
</style>
